import React, {useEffect, useState} from "react";
import CircularTrack from "../CircularTrackInput";
import { getRoundSteps, getStepValue, getRoundStepFromMinute } from "./utils";
import PropTypes from 'prop-types'

const accuracy = 1/60

const RoundTimeSelector = ({steps, selectedStep, onChange, ...restProps}) => {
  const roundSteps = getRoundSteps(steps)
  const defaultSelectedStep = getRoundStepFromMinute(selectedStep.minute, roundSteps)
  const defaultTrackValue = defaultSelectedStep.minValue
  const [tempTrackValue, setTempTrackValue] = useState(defaultTrackValue)
  const [step, setStep] = useState(defaultSelectedStep)
  const minValue = steps[0].minute
  const maxValue = steps[steps.length - 1].minute
  useEffect(() => {
    (step.step.minute !== selectedStep.minute) && onChange(step.step)
  }, [step.minValue])

  useEffect(() => {
    setStep(getStepValue(tempTrackValue, roundSteps))
  }, [tempTrackValue])

  useEffect(() => {
    const newStep = getRoundStepFromMinute(selectedStep.minute, roundSteps)
    setStep(newStep)
    setTempTrackValue(newStep.maxValue)
  }, [selectedStep])
  const limitMaxExceeded = step.step.minute === maxValue
  const limitMinExceeded = step.step.minute === minValue

  return <CircularTrack
      circleBackgroundColor={step.step.minute < 60 ? 'gray' : 'main'}
      progressColor='main'
      pointerColor={limitMaxExceeded || limitMinExceeded ? 'warning' : 'white'}
      maxValue={roundSteps[roundSteps.length - 1].maxValue}
      minValue={roundSteps[0].minValue}
      onChange={setTempTrackValue}
      value={tempTrackValue}
      accuracy={accuracy}
      {...restProps} />
}

RoundTimeSelector.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedStep: PropTypes.object.isRequired,
  onChange: PropTypes.func
}

RoundTimeSelector.defaultProps = {
  onChange: () => {},
}

export default RoundTimeSelector
